<template>
  <div class="modal-popup">
<!--    <div class="modal fade show" id="loginPopupForm" tabindex="-1" role="dialog"  aria-hidden="true" data-backdrop="static" keyboard="false">-->
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div>
              <h5 class="modal-title title" id="exampleModalLongTitle2">Giriş</h5>
              <p class="font-size-14">{{ cruiseBrandName }} Panel Girişine Hoş Geldiniz</p>
            </div>
          </div>
          <div class="modal-body">
            <div class="contact-form-action">
              <form id="loginForm" action="/login">
                <div class="input-box">
                  <label class="label-text">E Posta</label>
                  <div class="form-group">
                    <span class="la la-user form-icon"></span>
                    <input class="form-control" v-model="email"
                           v-on:keyup.enter="login()"
                           style="padding-left: 40px!important;"
                           type="text" name="username" id="login-username" placeholder="Email">
                  </div>
                </div><!-- end input-box -->
                <div class="input-box">
                  <label class="label-text">Parola</label>
                  <div class="form-group mb-2">
                    <span class="la la-lock form-icon"></span>
                    <input class="form-control" v-model="password"
                           v-on:keyup.enter="login()"
                           style="padding-left: 40px!important;"
                           type="password" name="password" id="login-password" placeholder="Parola">
                  </div>
                </div>
                <div class="btn-box pt-3 pb-4">
                  <button type="button" @click="login" class="theme-btn w-100">Giriş</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
<!--    </div>-->
  </div>
</template>

<script>
import messagePopupManager from "../util/messagePopupManager";

export default {
  name: "LoginPage",
  components: {},
  data:function (){
    return{
      email : "",
      password : "",
    }
  },
  computed:{
    cruiseBrandName:{
      get(){
        return window.cruiseBrandName;
      }
    },
  },
  methods:{
    login(){
      let request = {
        email: this.email,
        password: this.password
      }

      this.$store.dispatch("login", request ).then((response)=>{
        $("#loginPopupForm").modal("hide")
        location.reload();
      }).catch((reason)=>{
        messagePopupManager.showError("Error","Invalid email or password.");
      })
    }
  },
  mounted() {
    $("#loginPopupForm").modal("show")
    // $(".preloader").hide()
  }
}
</script>

<style>
</style>